// Twin of common/normalization_whitespace.py. Index IDs follow the Python
// writer; chart keys follow the browser writer. Explicit sets preserve
// existing stored keys without looking up a second spelling.
const COMMON_WHITESPACE =
  '\u0009\u000a\u000b\u000c\u000d\u0020\u00a0\u1680'
  + '\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007'
  + '\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000';

// Python also strips the four information separators and NEXT LINE.
export const INDEX_WHITESPACE = COMMON_WHITESPACE + '\u001c\u001d\u001e\u001f\u0085';
// Browser trim instead includes the byte-order mark.
export const DISPLAY_KEY_WHITESPACE = COMMON_WHITESPACE + '\ufeff';

export function trimWhitespace(value, characters) {
  return String(value ?? '').replace(new RegExp(`^[${characters}]+|[${characters}]+$`, 'g'), '');
}
